export default {
  SET_defaultTotal(state, value) {
    state.defaultTotal = value;
  },
};
